import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Document, Page, pdfjs } from 'react-pdf'
import React from 'react'
import { Media } from '@assembly/shared/types/media'
import 'react-pdf/dist/Page/TextLayer.css'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

type ContractViewerDialogProps = {
    open: boolean
    onClose: () => void
    contractURL: string
    resourceName: string
}

export default function ContractViewerDialog({
    open,
    onClose,
    contractURL,
    resourceName,
}: ContractViewerDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                Contract - {resourceName}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent dividers>
                <PDFViewer pdfURL={contractURL} />
            </DialogContent>
        </Dialog>
    )
}

function PDFViewer(props: { pdfURL: string }) {
    const [numPages, setNumPages] = React.useState<number>()

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages)
    }

    return (
        <Document file={props.pdfURL} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
                <Box key={`pdf-page-${index}`}>
                    <Page
                        renderAnnotationLayer={false}
                        width={850}
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderTextLayer={false}
                    />
                    <Divider />
                </Box>
            ))}
        </Document>
    )
} 